<template>
    <div class="single-page-helpCenter">
        <div class="main-section">
            <div class="left">
                <div class="tab-list">
                    <template v-for="(item, index) in tabList">
                        <div
                            @click="handleClickTab(index)"
                            :key="index"
                            :class="['item', index === currentTab && 'active']"
                        >
                            <div class="icon">
                                <img
                                    :src="
                                        require(`../../assets/helpCenter/help-list-icon-${index +
                                            1}${index === currentTab ? '-active' : ''}.png`)
                                    "
                                    alt=""
                                />
                            </div>
                            <div class="name">
                                {{ item.name }}
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="right">
                <div class="content-section">
                    <template v-if="cancellationMode">
                        <Cancellation :user-info="userInfo" :on-exit="toggleCancellationMode"></Cancellation>
                    </template>
                    <template v-else>
                        <div class="title">
                            {{ contentList[currentTab].title }}
                        </div>
                        <div class="content-list">
                            <template v-for="(item, index) in contentList[currentTab].subList">
                                <div :key="index" class="item">
                                    <div class="sub-title">
                                        {{ item.title }}
                                    </div>
                                    <div v-if="item.des" class="des">
                                        {{ item.des }}
                                    </div>
                                    <template v-if="item.subList">
                                        <template v-for="(subItem, subIndex) in item.subList">
                                            <div :key="subIndex" class="des sub-des">
                                                {{ subItem }}
                                            </div>
                                        </template>
                                    </template>
                                    <div v-if="item.vDes" class="des" v-html="item.vDes"></div>
                                    <div v-if="item.slot" v-html="item.slot" class="slot"></div>
                                    <div v-if="item.jump" class="jump-btn" @click="emitHanlder(item.jump.handler)">
                                        {{ item.jump.name }}
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="es6">
import Cancellation from '../../components/Cancellation';

import { getEnv,getUrlStrs,openWebPage,getPageUrl } from '../../../common/module/utils';
import { BOM } from '../../../common/module/BOM';
import { request } from '../../../common/module/request';
import { init, track } from '../../../common/module/TrackerWrapper';

export default {
    name: 'App',
    data: () => {
        return {
            tabList: [
                {
                    name: 'Pokekaraについて'
                },
                {
                    name: 'アカウントについて'
                },
                {
                    name: '録音について'
                },
                {
                    name: '採点について'
                },
                {
                    name: '再生について'
                },
                {
                    name: '投稿について'
                },
                {
                    name: 'その他'
                }
            ],
            contentList: [
                {
                    title: 'Pokekaraについて',
                    subList: [
                        {
                            title: '1.Pokekaraはどんなアプリですか？',
                            des: 'Pokekaraは 最新の邦楽からアニソン、ボカロ曲まで スマホ1つあればいつでもどこでも無料でカラオケが歌えるアプリです。'
                        },
                        {
                            title: '2.対応機種と推薦環境を教えてください。',
                            des: '対応機種と推薦環境は以下の通りでございます。',
                            slot: `<div class="slot-1-wrapper"><div class="slot-item">【iOS】- iOS10.0 以降</div><div class="slot-item">【Android】- Android4.4 以降</div></div>`
                        }
                    ]
                },
                {
                    title: 'アカウントについて',
                    subList: [
                        {
                            title: '1.ログイン方法は何がありますか？',
                            des: 'Twitter、Facebook、Line、電話番号からログインできます。ログイン後、Pokekaraアカウントと連携することになります。',
                            slot: `<div class="slot-2-wrapper"><div class="slot-item line"></div><div class="slot-item fb"></div><div class="slot-item tw"></div><div class="slot-item phone"></div></div>`
                        },
                        {
                            title: '2.プロフィール情報の変更方法は？',
                            des: 'マイページ→右上の「編集」からアイコン、ニックネーム、自己紹介などの情報を変更することができます。'
                        },
                        {
                            title: '3.アカウントの引き継ぎ方法は？',
                            des: '機種変更をされた場合、新しい端末から連携しているSNSのアカウントでログインしていただければアカウントの引き継ぎができます。 ただし、未発表作品は携帯端末の方に保存されていますので、機種変更の場合、未発表作品は引き継ぎができません。'
                        },
                        {
                            title: '4.アンインストールしてしまった時はどうやって復元しますか？',
                            des: 'アプリを再インストールしていただき、登録時のアカウントで再度ログインしていただければ、利用していたアカウントが復元されます。'
                        },
                        {
                            title: '5.メインアカウントとの連携を解除したいです。',
                            des: 'メインアカウントは最初に選択した登録方法で登録したアカウントです。メインアカウントとの連携を解除することはできません。'
                        },
                        {
                            title: '6.アカウントを削除したいです。',
                            jump: {
                                name: '私は注意事項を十分に理解した上、アカウントを削除する >',
                                handler: 'toggleCancellationMode'
                            },
                            des: 'www.pokekara.comにアクセスして、「FAQ」→「アカウントについて」→「アカウントを削除したいです」をクリックして、ログインしてから次のページでアカウントを削除できます。',
                        }
                    ]
                },
                {
                    title: '録音について',
                    subList: [
                        {
                            title: '1.音程バーが塗りつぶされません。',
                            des: '音程が異なる場合、音程バーが塗りつぶされないことがあります。録音画面左下のボタンでキーを調整できますので、一番ふさわしいキーに調整してみてください。また、使用するイヤホンはマイク付きの有線イヤホンをおすすめします。それでも問題を解決できなかった場合、フィードバックまでお問い合わせください。'
                        },
                        {
                            title: '2.低い声に反応しません。',
                            des: '録音画面左下のボタンでキーを調整できます。キーを調整しても反応しない場合は、フィードバックにてお使いの機種とイヤホンのタイプを教えてください。また、曲を一度アップロードしてください。'
                        },
                        {
                            title: '3.音声がうまく入りません。',
                            des: '使用するイヤホンは、マイク付きの有線イヤホンをおすすめします。また、録音画面左下のボタンをタップして、声/エコーと伴奏の音量も調整できます。'
                        },
                        {
                            title: '4.エコーとは？',
                            des: 'エコーとは周りがあまり静かでない時に、伴奏と声をきれいに聞こえるための機能です。'
                        },
                        {
                            title: '5.エコーが遅延に聞こえます。',
                            des: 'ワイヤレスイヤホンをお使いの場合は遅延がひどくなりますので、ワイヤレスイヤホンを使う場合はエコーをオフにすることをおすすめします。できれば、マイク付きの有線イヤホンをお使いください。それでも問題を解決できなかった場合、フィードバックにて機種とイヤホンのタイプを教えてください。'
                        },
                        {
                            title: '6.エコーがかかりません。どうしたらいいですか？',
                            des: 'Androidをご利用の場合は、機種によってエコーに対応していない可能性があります。フィードバックにてお使いの携帯の機種を教えてください。なるべく多くの機種に対応できるよう努力してまいります。ご不便をおかけして大変申し訳ございません。'
                        },
                        {
                            title: '7.キーを調整したいです。',
                            des: '録音画面左下のボタンでキーを調整できます。その他に、ガイドメロディのON/OFF、声/エコー、伴奏なども調整できます。'
                        },
                        {
                            title: '8.ガイドメロディ（音程のリード）をつけるにはどうしたらいいですか？',
                            des: '初期設定時のガイド機能は「オフ」になっております。ガイドを「オン」にされたい場合、録音画面左下の調整ボタンをタップし、ガイドを「オン」にしてください。'
                        },
                        {
                            title: '9.音がズレてしまう対処法を教えてください。',
                            des: 'ワイヤレスイヤホンを使用している場合、音がズレる可能性が大きいので、マイク付き有線イヤホンがおすすめです。また、編集画面で音ズレを調整できる機能を搭載しておりますので、お試しください。'
                        },
                        {
                            title: '10.雑音がひどいです。',
                            des: 'フィードバックにてお使いの機種とイヤホンのタイプ、曲名と歌手名を教えてください。また、一曲アップロードしてみてください。'
                        }
                    ]
                },
                {
                    title: '採点について',
                    subList: [
                        {
                            title: '1.採点の仕方が分かりません。',
                            des: '当アプリは音程が主な採点基準になります。現在黄色の「採点」マークがついている曲のみ、採点機能に対応しています。採点曲の「歌う」ボタンを押すと自動的に採点が開始します。採点をON/OFFに切り替える機能は現在対応しておりません。'
                        }
                    ]
                },
                {
                    title: '再生について ',
                    subList: [
                        {
                            title: '1.録音したものを聴くと声がズレていて伴奏より遅れます。',
                            des: '音ズレ調整機能を使用してみてください。まだズレがある場合は、フィードバックにて機種、イヤホン、曲名などの情報を教えてください。'
                        },
                        {
                            title: '2.作品が再生されません。',
                            des: 'フィードバックにて再生できない作品のユーザーID、曲名と歌手名を教えてください。'
                        }
                    ]
                },
                {
                    title: '投稿について',
                    subList: [
                        {
                            title: '1.アップロードできません。',
                            des: '60秒以上の作品しかアップロードできませんので、予めご了承下さい。'
                        },
                        {
                            title: '2. 非公開の仕方はどうすればいいのですか？',
                            des: '作品を非公開にする手順：マイページ→非公開にしたい作品をタップして再生→右下の「more」→「自分のみ」を選択してください 。'
                        },
                        {
                            title: '3. アップした歌を削除したいです。',
                            des: '作品を削除する手順：マイページ→削除したい作品をタップして再生→右下の「more」→「削除」をタップすると作品を削除できます。'
                        }
                    ]
                },
                {
                    title: 'その他',
                    subList: [
                        {
                            title: '1.通知をオフにしたいです。',
                            vDes: '<div>Android：設定→音と通知→アプリの通知→ Pokekaraをタップすれば、「アプリの通知」画面が表示されますので、通知のオン/オフ、通知の条件などを細かく設定できます。<br>IOS ： 設定→通知→ Pokekaraをタップすれば、「アプリの通知」画面が表示されますので、通知のオン/オフ、通知の条件などを細かく設定できます。<br>また、アプリ内のマイページ→設定→通知設定からもフォロー、コメント、アイテム、フォローユーザーの新曲など、通知の種類を細かく設定できます。</div>'
                        },
                        {
                            title: '2.不適切なコメントを消したいです。',
                            des: 'コメントの内容を長押しして、「削除」をタップしていただければコメントを削除できます。'
                        },
                        {
                            title: '3.アイテムはどうやって獲得できますか？',
                            des: '毎日ログイン、作品のアップロード、シェアをする度に特典としてアイテムのペンライトを獲得できます。詳しくはマイページのマイミッションにてご確認下さい。また、他の方からアイテムが贈られた場合、マイページのアイテムよりご確認いただけます。'
                        },
                        {
                            title: '4.ペンライトって何ですか？',
                            des: 'ペンライトは好きな作品やユーザーを応援するための無料アイテムです。他のユーザーからペンライトが贈られてきたら、そのユーザーはあなたの作品を気に入ったということになります。ペンライトを贈られるとあなたの作品は人気度が高くなり、人気ランキングでの順位も上がります。もらったペンライトは再度他のユーザーに贈ることはできませんが、毎日ミッションをクリアするとペンライトを獲得して他のユーザーに贈ることができます。'
                        },
                        {
                            title: '5.他のユーザーをブロックしたいです。',
                            des: 'ブロックしたいユーザーのプロフィールページに入り、右上のボタンをタップして、「ブロックする」を押すと該当のユーザーをブロックできます。'
                        },
                        {
                            title: '6. 人気ランキングとはなんですか？',
                            des: 'POKE人気ランキングは、作品の再生回数、コメント、ペンライトの数とこれらの行為に応じるユーザー数などを総合的に計算し、ランキング化しています。ルールの詳細についてはランキングの「ルールの説明」をご参考ください。'
                        },
                        {
                            title: '7.DM をオフにしたいです。',
                            des: 'マイページ-設定-DM設定でDMをOFFにすることができます。'
                        }
                    ]
                }
            ],
            cancellationMode: false,
            currentTab: 0,
            userInfo: {}
        };
    },
    components: {
        Cancellation
    },
    watch: {
        currentTab(newTab, oldTab) {
            if (newTab !== 1 && oldTab === 1) {
                this.cancellationMode = false;
            }
        }
    },
    methods: {
        getUserInfo() {
            const self = this;
            return new Promise((res, rej) => {
                if (BOM.window.userInfo) {
                    self.userInfo = BOM.window.userInfo;
                    res();
                    return;
                }
                request({
                    url:"/x/user/my_info",
                    callback:(data)=>{
                        if(data.err_code===0){
                            self.userInfo = data.data.user;
                            res();
                        }else {
                            const host = `${getEnv() === 'cdn' ? 'https://www.pokekara.com' : window.location.origin}`;
                            const url = `${host}/?page=cancellation#/?originPage=helpCenter&login=true`;
                            window.location.href = url;
                            rej();
                        }
                    }
                });
            });
        },
        emitHanlder(handler) {
            const self = this;
            self[handler] && self[handler]();
        },
        async toggleCancellationMode() {
            track('poke_web_FAQ', 'click_FAQ_logOff');
            const page=getPageUrl('cancellation','v2')+'?theme_name=Light';
            openWebPage(page);
        },
        handleClickTab(index) {
            this.currentTab = index;
            const o = {
                Pokekaraについて: 'click_FAQ_poke',
                アカウントについて: 'click_FAQ_account',
                録音について: 'click_FAQ_record',
                採点について: 'click_FAQ_grad',
                再生について: 'click_FAQ_play',
                投稿について: 'click_FAQ_publish',
                その他: 'click_FAQ_other'
            };
            const label = o[this.tabList[index].name];
            label && track('poke_web_FAQ', label);
        }
    },
    async mounted() {
        !BOM.window.trackerWeb && init('', '', '1279353603');
        const self = this;
        // 需要登录后直接进入注销页，但是没有登录，然后回到帮助中心时，防止直接提示登录
        if (getUrlStrs().page === 'cancellation') {
            try {
                await new Promise((res, rej) => {
                    request({
                        url:"/x/user/my_info",
                        callback:(data)=>{
                            if(data.err_code===0){
                                res();
                            }else {
                                rej();
                            }
                        }
                    });
                });
            } catch (e) {
                return;
            }
            self.currentTab = 1;
            self.cancellationMode = true;
            BOM.window.history.replaceState({},'', "/" + BOM.window.location.hash);
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../../common/sass/basic/_common.scss';
@import '../../../common/sass/basic/mixin';
@import './style';
</style>
